<nc-confirmation-dialog titleLabel="newRequest">
	<p id="newRequestMessage">{{ 'newRequestMessage' | translate }}</p>
	<br /><br />
	<p innerHTML="{{ 'yourTellcoTeam' | translate }}"></p>
</nc-confirmation-dialog>
